import { render, staticRenderFns } from "./targeting.vue?vue&type=template&id=cbc83b54&scoped=true"
import script from "./targeting.vue?vue&type=script&lang=js"
export * from "./targeting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc83b54",
  null
  
)

export default component.exports